export const APP_NOTIFY_EVENT = 'app:notify';

export const notify = ({
  type = 'info',
  title = '',
  message = '',
  durationMs = 2600,
} = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(APP_NOTIFY_EVENT, {
    detail: {
      type,
      title,
      message: String(message || '').trim() || 'Action completed.',
      durationMs: Number(durationMs) || 2600,
    },
  }));
};

export const notifySuccess = (message, title = 'Submitted', durationMs = 2600) =>
  notify({ type: 'success', title, message, durationMs });

export const notifyError = (message, title = 'Error', durationMs = 3200) =>
  notify({ type: 'error', title, message, durationMs });

export const notifyWarning = (message, title = 'Warning', durationMs = 3000) =>
  notify({ type: 'warning', title, message, durationMs });

export const notifyInfo = (message, title = 'Notice', durationMs = 2600) =>
  notify({ type: 'info', title, message, durationMs });
